export const NAME = "navigation";

/**
 * Pomocná funkce pro vytvoření typu akce
 * @param actionTypeName Typ akce
 */
const createActionType = (actionTypeName: string) => `${NAME}/${actionTypeName}`;

export const SET_FOCUSED_ITEM = createActionType("SET_FOCUSED_ITEM");
export const FOCUS_DEFAULT_ITEM = createActionType("FOCUS_DEFAULT_ITEM");
export const CLEAR_FOCUSED_ITEM = createActionType("CLEAR_FOCUSED_ITEM");
export const SET_NAVIGATION_NODES = createActionType("SET_NAVIGATION_NODES");
export const CLEAR_NAVIGATION_SECTION = createActionType("CLEAR_NAVIGATION_SECTION");
export const NAVIGATION_NODES_UPDATED = createActionType("NAVIGATION_NODES_UPDATED");
export const KEY_PRESSED = createActionType("KEY_PRESSED");
export const MENU_FOCUS_LOST = createActionType("MENU_FOCUS_LOST");
export const ACTION_ITEM_FOCUSED = createActionType("ACTION_ITEM_FOCUSED");
